import styled from 'styled-components';

export const SearchPopupContent = styled.div`
  padding: 15px;
  height: 100%;
  position: relative;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 4px;
  }

  > div:first-child {
    background-color: ${({ theme }) => theme.colors.background.primary};
    margin-bottom: 15px;

    &:focus-within {
      border-color: ${({ theme }) => theme.colors.systemColors.blue};
    }

    @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
      margin-bottom: 20px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 20px 25px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding: 20px 45px;
  }
`;
